export default __webpack_public_path__ + "Revenue_Calculator_New_Product_Template_EU-pt-BR.657e24c9.xlsx";